import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignLanguageComponent} from './sign-language/sign-language.component';
import {HelpRoutingModule} from './help-routing.module';

@NgModule({
  imports: [
    CommonModule,
    HelpRoutingModule
  ],
  declarations: [
    SignLanguageComponent
  ]
})
export class HelpModule {
}



// WEBPACK FOOTER //
// ./src/app/help/help.module.ts